import { useContext } from 'react'

import { ErrorContextType } from '@types'
import { ErrorContext } from '@context/ErrorContext'

export const useError = (): ErrorContextType => {
  const context = useContext(ErrorContext)
  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider')
  }
  return context
}
